import { render } from "./ViewProductView.vue?vue&type=template&id=4e595dae&scoped=true"
import script from "./ViewProductView.vue?vue&type=script&lang=js"
export * from "./ViewProductView.vue?vue&type=script&lang=js"

import "./ViewProductView.vue?vue&type=style&index=0&id=4e595dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e595dae"]])

export default __exports__